export default __webpack_public_path__ + "static/media/img1.28b7db0a.jpeg";